import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BlobStorageService } from 'src/app/_modules/shared/_services/blob-storage.service';
import { VoltageTypes } from 'src/app/enums/voltage-types.enum';
import { AssetStatusEnum } from 'src/app/models/assetStatus.model';
import { ContainerNames } from 'src/app/models/containerNames.model';
import { DTFencingStatus, DTStatus } from 'src/app/models/dt.model';
import { ImageType } from 'src/app/models/image.model';
import { getInitRmuEdit, RmuDtoCreate, RmuEdit } from 'src/app/models/rmu.model';
import { PermissionsEnum } from 'src/app/models/role.model';
import { User } from 'src/app/models/user.model';
import { PermissionsService } from 'shared-lib';
import { RmuService } from 'src/app/services/rmu.service';
import { TranslationService } from 'src/app/services/translation.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-edit-rmu',
  templateUrl: './edit-rmu.component.html',
  styleUrls: ['./edit-rmu.component.scss'],
})
export class EditRmuComponent implements OnInit {
  @ViewChild('closeAudit') auditReviewModal: ElementRef;
  @ViewChild('dropdownContainer') dropdownContainer: ElementRef;
  @ViewChild('userFilterInput') userFilter: ElementRef;
  @ViewChild('closeModal') closeModal: ElementRef;

  @ViewChild('openUpdateDescriptionModal')
  openUpdateDescriptionModal: ElementRef;
  public PermissionsEnum = PermissionsEnum;
  dateManufacturerString: string | null;
  dateComissionString: string | null;
  id: number = 0;
  imgElement: any;
  imgZoomFullContainer: any;
  currentRotation: number = 0;
  rmu: RmuEdit = getInitRmuEdit();
  filterText: string = '';
  isDropdownOpened: boolean = false;
  filteredMobileUsers: User[] = [];
  mobileUsers: User[] = [];
  assetAssignType: AssetStatusEnum;
  AssetAssignType = AssetStatusEnum;
  showRecallMenu: boolean = false;
  recallAssignedAllowed: boolean = false;
  recallValidatedAllowed: boolean = false;
  tempAssignedUserId: number = 0;
  assignedUserId: number = 0;
  isMapVisible: boolean = false;
  isImageMapVisible: boolean = false;
  ImageType = ImageType;
  selectedImage: any;
  editEnabled: boolean = false;
  newImage: File | null;

  voltageLevelOptions: string[] = ['KV11', 'KV33'];
  statusOptions: string[] = ['Active', 'Inactive', 'Suspended', 'Decommissioned'];
  fencedStatusOptions: string[] = ['NoFence', 'Fenced', 'Compact'];
  rmuTypeOptions: string[] = ['Gas-insulated', 'Air-insulated', 'Vacuum'];

  voltageLevelMap: { [key in VoltageTypes]: string } = {
    [VoltageTypes.KV11]: 'KV11',
    [VoltageTypes.KV33]: 'KV33',
  };

  statusMap: { [key in DTStatus]: string } = {
    [DTStatus.Active]: 'Active',
    [DTStatus.Inactive]: 'Inactive',
    [DTStatus.Suspended]: 'Suspended',
    [DTStatus.Decommissioned]: 'Decommissioned',
  };

  fencedStatusMap: { [key in DTFencingStatus]: string } = {
    [DTFencingStatus.NoFence]: 'NoFence',
    [DTFencingStatus.Fenced]: 'Fenced',
    [DTFencingStatus.Compact]: 'Compact',
  };
  tempVoltageLevel: VoltageTypes;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private toastr: ToastrService,
    private translationService: TranslationService,
    public permissionsService: PermissionsService,
    private el: ElementRef,
    private renderer: Renderer2,
    private blobStorageService: BlobStorageService,
    private rmuService: RmuService
  ) {}

  ngOnInit(): void {
    const routeId = this.route.snapshot.paramMap.get('id');
    this.blobStorageService.setContainer(ContainerNames.Images);
    this.id = parseInt(routeId == null ? '0' : routeId);
    this.getRmuDetails(this.id);
    this.imgElement = this.el?.nativeElement?.querySelector(
      '.ngxImageZoomThumbnail'
    );
    this.imgZoomFullContainer =
      this.el?.nativeElement?.querySelector('.ngxImageZoomFull');
  }
  private getRmuDetails(rmuId: any) {
    this.rmuService.get(rmuId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.rmu = responseData.data;
          this.assignedUserId = this.rmu.assignedUserId || 0;
          this.tempAssignedUserId = this.assignedUserId;
          this.filterText = this.rmu.assignedUser;
          this.tempVoltageLevel = this.rmu.voltageLevel;
       
          this.dateManufacturerString = this.rmu.manufactureDate
            ? new Date(this.rmu.manufactureDate).toISOString().split('T')[0]
            : null;
          this.dateComissionString = this.rmu.commissioningDate
            ? new Date(this.rmu.commissioningDate).toISOString().split('T')[0]
            : null;

          if (this.rmu.assetStatus.toString() === 'Assigned') {
            this.recallAssignedAllowed = true;
          }
          // if (
          //   this.dt.dataValidationReview != null &&
          //   this.dt.dataValidationReview.length > 0
          // ) {
          //   this.modalRejectionReason = this.dt.dataValidationReview.find(
          //     (x) => x.key == 'Reason for rejection'
          //   )?.value;
          // }
          if (this.rmu.dataQualityId !== 0) {
            this.recallValidatedAllowed = true;
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  updateVoltageLevel() {
    this.rmu.voltageLevel = this.tempVoltageLevel;
  }

  disableUpdateStatusButton() {
    if (this.rmu.dataQualityId === 0) return false;
    else return true;
  }
  getMobileUsers() {
    this.userService
      .getMobileUsers(this.rmu.areaId, this.filterText)
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.mobileUsers = responseData.data;
            if (this.mobileUsers.length == 0) {
              this.isDropdownOpened = false;
            } else {
              this.isDropdownOpened = true;
            }
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occured');
        },
      });
  }
  setModalType(type: AssetStatusEnum) {
    this.assetAssignType = type;
  }
  recall() {
    this.rmuService.recall(this.id).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success('Successfully recalled RMU.');
          window.location.reload();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  disableAuditReviewButton() {
    if (this.rmu.auditedStatus === 'Audited') return true;
    else return false;
  }
  cancelAudit() {
    this.auditReviewModal?.nativeElement?.click();
  }
  onModalAssignFade() {
    this.filterText = this.rmu.assignedUser;
  }
  filterMobileUsers() {
    this.isDropdownOpened = true;
    this.tempAssignedUserId = 0;
    this.getMobileUsers();
  }
  openDropdown() {
    this.isDropdownOpened = true;
  }
  selectFieldAgent(id: number) {
    this.isDropdownOpened = false;
    this.rmu.assignedUserId = id;
    this.tempAssignedUserId = id;
    var mobUser = this.mobileUsers.find((x) => x.id == id);
    this.filterText = mobUser!.fullName;
  }

   setDateOfManufacturer() {
    this.rmu.manufactureDate = this.dateManufacturerString ? new Date(this.dateManufacturerString) : null;
  }

  setDateOfComission() {
    this.rmu.commissioningDate = this.dateComissionString ? new Date(this.dateComissionString) : null;
  }

  assignTask(): void {
    if (
      this.mobileUsers.filter((x) => x.fullName == this.filterText.trim())
        .length > 0
    ) {
      this.assignedUserId = this.mobileUsers.filter(
        (x) => x.fullName == this.filterText.trim()
      )[0].id;
      this.tempAssignedUserId = this.assignedUserId;
    } else {
      this.tempAssignedUserId = 0;
    }
    if (this.tempAssignedUserId != 0) {
      this.rmuService
        .assignRmu(this.id, this.assignedUserId, this.assetAssignType)
        .subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.closeModal?.nativeElement?.click();
              this.rmu.assignedUserId = this.assignedUserId;
              this.toastr.success('Successfully assigned user');
              window.location.reload();
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured');
          },
        });
    } else {
      this.toastr.warning('Please select valid user.');
    }
  }
   getImageByType(imageType: string) {
    return this.rmu.images.find((x) => x.imageType.toString() === imageType);
  }

   getMountedTagImage() {
    return this.rmu.images.find((x) => x.imageType.toString() === 'MountedTag')
      ?.url;
  }
    getRMUImage() {
    return this.rmu.images.find((x) => x.imageType.toString() === 'RMU')
      ?.url;
  }
    getNameplatePictureImage() {
    return this.rmu.images.find((x) => x.imageType.toString() === 'NameplatePicture')
      ?.url;
  }
    getCableEntryPointsImage() {
    return this.rmu.images.find((x) => x.imageType.toString() === 'CableEntryPoints')
      ?.url;
  }
    showImage(imageType: ImageType) {
    switch (imageType) {
      case ImageType.MountedTag: {
        this.selectedImage = this.getImageByType('MountedTag');
        break;
      }
      case ImageType.RMU: {
        this.selectedImage = this.getImageByType('RMU');
        break;
      }
      case ImageType.NameplatePicture: {
        this.selectedImage = this.getImageByType('NameplatePicture');
        break;
      }
      case ImageType.CableEntryPoints: {
        this.selectedImage = this.getImageByType('CableEntryPoints');
        break;
      }
      default:
        this.selectedImage = undefined;
    }
  }
  fileBrowserHandler({ file, type, imageId }: { file: File, type: ImageType, imageId: number }) {
    if (!file) {
      this.toastr.error('Image data is missing');
      return;
    }
  
    this.newImage = file;

    // Upload the image to blob storage first
    this.blobStorageService.uploadFile(
      this.newImage,
      this.newImage.name,
      (uploadedUrl) => {
        const obj = {
          imageType: type,
          entityId: this.id,
          guid: this.rmu.guid,
          url: uploadedUrl,
          imageId: imageId,
        };

        this.rmuService.uploadPicture(obj, this.newImage!).subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              const images = this.rmu.images.filter(
                (x) => x.imageType.toString() == ImageType[type]
              );
              const imageIndex = this.rmu.images.indexOf(images[imageId]);
              this.rmu.images[imageIndex] = responseData.data;
              this.toastr.success('Successfully added image');
              this.getRmuDetails(this.id);
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occurred while saving image metadata');
          },
        });
      },
      (error) => {
        console.error('Error uploading image to blob storage:', error);
        this.toastr.error('Failed to upload image to storage');
      }
    );
  }
    onModalFade() {
    this.currentRotation = 0;

    if (this.imgZoomFullContainer) {
      var displayValue = getComputedStyle(this.imgZoomFullContainer).display;

      if (displayValue == 'block') {
        this.imgElement.click();
      }
    }
  }
   onModalOpen() {
    this.renderer.setStyle(document.body, 'overflow', 'auto');
    this.renderer.setStyle(document.body, 'overflow-x', 'hidden');
    this.renderer.setStyle(document.body, 'padding-right', '0');
  }
  
  rotateLeft() {
    this.currentRotation -= 90;
  }

  rotateRight() {
    this.currentRotation += 90;
  }

  edit() {
    this.editEnabled = true;
  }

  validateInput(event: Event) {
    let hasErrors = false;
    
    if (!this.rmu.serialNumber) {
      this.toastr.error("Serial Number cannot be empty!");
      hasErrors = true;
    }
    if (!this.rmu.manufacturerName) {
      this.toastr.error("Manufacturer Name cannot be empty!");
      hasErrors = true;
    }
    if (!this.rmu.locationAddress) {
      this.toastr.error("Location Address cannot be empty!");
      hasErrors = true;
    }
    if (!this.rmu.locationLandmark) {
      this.toastr.error("Location Landmark cannot be empty!");
      hasErrors = true;
    }
    if (this.rmu.numberOfOutput < 0) {
      this.toastr.error("Number of outputs cannot be less than zero!");
      hasErrors = true;
    }
 
    if (!hasErrors) {
      this.save();
    }
  }
  
  save(){
    const rmuDtoCreate: RmuDtoCreate = {
    id: this.id,
    voltageLevel: this.voltageLevelMap[this.rmu.voltageType as VoltageTypes] || this.rmu.voltageLevel.toString(),
    status: this.statusMap[this.rmu.dtStatus as DTStatus] || this.rmu.dtStatus.toString(),
    fencedStatus: this.fencedStatusMap[this.rmu.fencedStatus as DTFencingStatus] || this.rmu.fencedStatus.toString(),
    manufacturerName: this.rmu.manufacturerName,
    serialNumber: this.rmu.serialNumber,
    numberOfOutput: this.rmu.numberOfOutput,
    type: this.rmu.type,
    manufactureDate: this.rmu.manufactureDate ? new Date(this.rmu.manufactureDate).toISOString() : null,
    commissioningDate: this.rmu.commissioningDate ? new Date(this.rmu.commissioningDate).toISOString() : null,
    locationAddress: this.rmu.locationAddress,
    locationLandmark: this.rmu.locationLandmark,
  };

  
    this.rmuService.save(rmuDtoCreate).subscribe({
    next: (response) => {
      const responseData = response.body;
      if (response.status === 200 || responseData?.status === 'OK') {
        this.toastr.success('Successfully saved RMU.');
        this.editEnabled = false; // Exit edit mode
        this.getRmuDetails(this.id); // Refresh the RMU details
      } else {
        this.toastr.error(responseData?.message || 'Failed to save RMU.');
      }
    },
    error: (error) => {
      this.toastr.error(error?.error?.message || 'Error occurred while saving RMU.');
    },
  });
  }

}
